import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import PageTitle from '../../../../components/partials/PageTitle'
import { getCustomerOverview } from '../../../../redux/slice/report/reportSlice';
import ReportFilter from './ReportFilter';
import { CSVLink } from 'react-csv';
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';

const CustomerOverview = () => {
    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false)

    const CCPdfRef = useRef()
    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const navigate = useNavigate();

    const {customerOverviewData} = useSelector((state) => state.report);
    const { user } = useSelector((state) => state.auth);

    const dispatch = useDispatch()

    const processedData = customerOverviewData?.map(row => {
      const fullName = `${row.first_name} ${row.last_name}`;
      const agent = `${row.agent_firstname} ${row.agent_lastname}`;
      const statusValue = row.status;
      let statusLabel = '';
  
      switch (statusValue) {
        case "1":
          statusLabel = 'pending';
          break;
        case "2":
          statusLabel = 'active';
          break;
        case "3":
          statusLabel = 'rejected';
          break;
        case "4":
          statusLabel = 'closed';
          break;
        default:
          statusLabel = 'unknown';
      }
  
      return { ...row, status: statusLabel, full_name: fullName, agent }; // Modify status property while keeping the rest
    }); 

    const headers = [
      { label: 'Customer ID', key: 'customer_id' },
      { label: 'Reg. Date', key: 'created_at' },
      { label: 'Full Name', key: 'full_name' },
      { label: 'Phone Number', key: 'customer_phone_number' },
      { label: 'Gender', key: 'gender' },
      { label: 'Agent', key: 'agent' },
      { label: 'Status', key: 'status' },
      { label: 'Office', key: 'office_name' },
    ];

    const breadcrumb = {
      from: {
        title: "Reports",
        link: "/admin/reports",
      },
      current: {
        title: "Customer Overview",
        link: null,
      },
    };

    // print table to pdf
    const generatePDF = useReactToPrint({
      content: () => CCPdfRef.current,
      documentTitle: "Customer Overview Report",
    });

    const uniqueCustomerCount = new Set(
      customerOverviewData?.map((item) => item.customer_id)
    ).size;


    useEffect(() => {
      if (filteredItem) {
        if (filterData.office_id === '') {
          const updatedFilterData = {
            ...filterData,
            office_id: user?.user?.office_id
          };
          dispatch(getCustomerOverview(updatedFilterData));
        }else{
          dispatch(getCustomerOverview(filterData));
        }
      }
    }, [dispatch, filterData, filteredItem, user?.user?.office_id])
    
    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'customer report module') || !user_permissions?.some(permission => permission.name === 'customer overview report')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Customer Overview' breadcrumb={breadcrumb} />
        {/* end page title */} 
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
          <ReportFilter 
            page={'customerOverview'}
            setFilterData={setFilterData}
            setFilteredItem={setFilteredItem}
            filteredItem={filteredItem}
          />
          {/* {keySuccess && <div className='my-3 p-1 ms-3'>
            <button type='button' className='btn btn-sm btn-primary d-flex gap-2 align-items-center' onClick={() => dispatch(getOverviewData(key))}>
              <i className='mdi mdi-eye text-white'></i>
              <span>View Report</span>
            </button>
          </div>} */}
          {customerOverviewData && <div className="row mb-3">
            <>
                <div className='d-flex justify-content-end align-items-center'>
                    <div className=' d-flex align-items-center border '>
                    <span
                        className='bg-info me-2 text-white'
                        style={{ padding: "3px" }}
                    >
                        Export to
                    </span>

                    <span
                        href='#'
                        id='btnExport'
                        className='me-1 cursor-p'
                        title='Export to Pdf'
                        onClick={generatePDF}
                    >
                        <img
                        src={pdf}
                        alt='export-pdf'
                        style={{ height: "25px" }}
                        />
                    </span>
                    {customerOverviewData ? (
                        <CSVLink
                        data={processedData}
                        style={{ fontWeight: "bolder", cursor: "pointer" }}
                        filename='Customer Overview Report'
                        headers={headers}
                        >
                          <span
                            href='#'
                            id='btnExport'
                            className='mr-1'
                            title='Export to Excel'
                          >
                            <img
                              src={excel}
                              alt='export-excel'
                              style={{ height: "25px", marginRight: "5px" }}
                            />
                          </span>
                        </CSVLink>
                    ) : null}
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className='table table-centered table-striped nowrap w-100 no-footer' ref={CCPdfRef}>
                        <thead>
                            <tr>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "100.8px" }}
                                    aria-label='Email: activate to sort column ascending'
                                >
                                  Customer Id
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "150.8px" }}
                                    aria-label='Customer: activate to sort column ascending'
                                >
                                  Name
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                  Phone Number
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                  Gender
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "156.8px" }}
                                    aria-label='Location: activate to sort column ascending'
                                >
                                  Agent
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Status
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Office
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                  Reg. Date
                                </th>
                            </tr>
                        </thead>
                        {customerOverviewData?.length ? <tbody>
                            {customerOverviewData?.map((item, i) => ( 
                                <tr key={i}>
                                    <td className='text-dark'>
                                        {item?.customer_id}
                                    </td>
                                    <td className='table-user'>
                                        <span
                                            className='text-body fw-semibold'
                                        >
                                            {item?.first_name} {item?.last_name}
                                        </span>
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.customer_phone_number}
                                    </td>                                      
                                    <td className='table-user'>
                                      {item?.gender}
                                    </td>                                      
                                    <td>{item?.agent_firstname} {item?.agent_lastname}</td>
                                    <td>
                                      {item?.status === "1" && "Pending"}
                                      {item?.status === "2" && "Active"}
                                      {item?.status === "3" && "Rejected"}
                                      {item?.status === "4" && "Closed"}
                                    </td>
                                    <td>{item?.office_name}</td>
                                    <td>{item?.created_at}</td>
                                </tr>
                                
                            ))}
                            <tr>
                              <td>Total Customers:</td>
                              <td colSpan='7' className='fw-bold'>
                                 {uniqueCustomerCount}
                              </td>
                            </tr>
                        </tbody> : null}
                    </table>
                    {customerOverviewData?.length < 1 ? (
                        <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                </div>
            </>
            </div>}
        </div>  
    </>
  )
}

export default CustomerOverview